module.exports = __webpack_public_path__ + "img/field_4.3eb3f563.jpg";